import { Typography } from '@stern-ui/ui';
import { createColumnHelper } from '@tanstack/react-table';
import clsx from 'clsx';

import { TableConfigType } from '@/components';
import { CreateContactLogResponse } from '@/features/patientEngagement';
import { formatSnakeCase, formatDate, formatLongDateTime, formatContactMethod } from '@/utils';

import { PATIENT_DETAILS } from '../consts';

const columnHelper = createColumnHelper<CreateContactLogResponse>();

const columns = [
	columnHelper.accessor<'created_at', string>('created_at', {
		header: () => (
			<Typography variant='bodySmall'>
				{PATIENT_DETAILS.CONFIGS.CONTACT_HISTORY.TABLE.COLUMNS.A.LABEL}
			</Typography>
		),
		cell: (info) => {
			return formatLongDateTime(info.getValue());
		},
	}),
	columnHelper.accessor<'contact_method', string>('contact_method', {
		header: () => (
			<Typography variant='bodySmall'>
				{PATIENT_DETAILS.CONFIGS.CONTACT_HISTORY.TABLE.COLUMNS.B.LABEL}
			</Typography>
		),
		cell: (info) => {
			if (info.getValue() === 'sms') {
				return <span className='uppercase'>{info.getValue()}</span>;
			} else {
				const text = formatContactMethod(info.getValue());
				return <span className='capitalize'>{text}</span>;
			}
		},
	}),
	columnHelper.accessor<'created_by.first_name', string>('created_by.first_name', {
		header: () => (
			<Typography variant='bodySmall'>
				{PATIENT_DETAILS.CONFIGS.CONTACT_HISTORY.TABLE.COLUMNS.C.LABEL}
			</Typography>
		),
	}),
	columnHelper.accessor<'outcome', string>('outcome', {
		header: () => (
			<Typography variant='bodySmall'>
				{PATIENT_DETAILS.CONFIGS.CONTACT_HISTORY.TABLE.COLUMNS.D.LABEL}
			</Typography>
		),
		cell: (info) => {
			const text = formatSnakeCase(info.getValue());
			return (
				<span
					className={clsx(
						info.getValue()
							? 'py-1 px-2 text-sm rounded-full bg-secondaryBackground capitalize'
							: null
					)}
				>
					{text}
				</span>
			);
		},
	}),
	columnHelper.accessor<'scheduled_at', string>('scheduled_at', {
		header: () => (
			<Typography variant='bodySmall'>
				{PATIENT_DETAILS.CONFIGS.CONTACT_HISTORY.TABLE.COLUMNS.E.LABEL}
			</Typography>
		),
		cell: (info) => {
			return formatDate(info.getValue());
		},
	}),
	columnHelper.accessor<'comment', string>('comment', {
		header: () => (
			<Typography variant='bodySmall'>
				{PATIENT_DETAILS.CONFIGS.CONTACT_HISTORY.TABLE.COLUMNS.F.LABEL}
			</Typography>
		),
	}),
];

export const contactHistoryTableConfig: TableConfigType = {
	columns,
	rowProps: { rowSelect: false },
};
